<template>
    <div class="textbox" v-show="isVisible">
        <div class="textbox__title">
            <label :for="id">{{title}}</label>
        </div>
        <validation-provider :name="name" :rules="rules"  v-slot="{ errors, failed, changed, validated, dirty}" :disabled="!isVisible">
            <div class="textbox__wrapper d-flex align-items-stretch" :class="{'has-error': failed && (changed || validated)}">
                <input type="text" :name="name" v-model="newValue" @keypress="validate"
                    :maxlength="maxLength" :id="id" />
            </div>
            <label v-if="failed && (changed || validated)">{{errors[0]}}</label>
        </validation-provider>
    </div>
</template>

<script>
    export default {
         props: {
            title: {
                type: String,
                default: () => ''
            },
            name: {
                type: String,
                default: () => 'name'
            },
            value: [String, Number],
            type: {
                type: String,
                default: () => "text"
            },
            rules: {
                type: String,
                default: () => ''
            },
            isVisible: {
                type: Boolean,
                default: () => true
            },
            maxLength : {
                type: String
            },
            id: {
                type: String
            }
        },     
        data() {
            return {
                newValue: this.value,
            }
        },
        watch: {           
            value(value) {
                this.newValue = value
            },
            newValue(value) {
                this.$emit('input', value)
            }
        },  
        methods: {
            validate(ev) {
                if (this.type !== 'number') return true
                var charCode = (ev.which) ? ev.which : ev.keyCode
                if ((charCode > 31 && (charCode < 44 || charCode > 57)) && charCode !== 46) {
                    ev.preventDefault()
                } else {
                    return true
                }
            }
        }
    }
</script>